<template>
  <a-modal v-model="isShow" title="Search" @ok="onSearchSubmit">
    <div style="padding-right: 10px">
      Card
      <a-input v-model="card" placeholder="" />
      <div style="margin: 10px 0" />

      Phone
      <a-input v-model="phone" placeholder="" />
      <div style="margin: 10px 0" />

      Remark
      <a-input v-model="remark" placeholder="" />
      <div style="margin: 10px 0" />
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    search: { type: Function }
  },
  components: {},
  data() {
    return {
      //
      card: "",
      phone: "",
      remark: "",
      //
      isShow: false
    };
  },
  methods: {
    onSearchSubmit() {
      this.isShow = false;
      this.search({
        card: this.card,
        phone: this.phone,
        remark: this.remark
      });
    },
    show() {
      this.isShow = true;
    }
  }
};
</script>

<style lang="scss"></style>
